import { busEvent } from '../components/events/bus';

export default function handlerError(err) {
  if (err.response && err.response.data && err.response.data.error) {
    // this error will be catch by axious response interceptor and it
    // will try to renew the token
    if (err.response.status === 401 && err.response.data.error.code !== 3) {
      busEvent.$emit('errorPopupCreated', err.response.data.error.message);
    }
  } else {
    busEvent.$emit('errorPopupCreated', err.message);
  }
}
